import { cx } from '@emotion/css';
import { Col, Row } from 'antd';
import { MButton, MFormTextField, MModalBody, MModalFooter, MModalTitle, MTypography, CurrencyField } from 'src/lib';
import { Position } from 'src/models';
import { AlignItems, BaseStyle, ColorConstant, Display, JustifyContent, Spacing } from 'src/styles';

import { SecurityDetailsCarousel } from './SecurityDetailsCarousel';

interface SecurityHoldingTradeDetailsStepProps {
  position: Position;
  onClose: () => void;
  onBuy?: () => void;
  onSell?: () => void;
}

export const SecurityHoldingTradeDetailsStep = ({
  position,
  onClose,
  onBuy,
  onSell,
}: SecurityHoldingTradeDetailsStepProps) => {
  return (
    <>
      <MModalTitle>Securities Details</MModalTitle>
      <MModalBody>
        <Col span={24} className={Spacing.my12}>
          <MTypography variant='h3' align='center' weight='semibold'>
            {position.description} ({position.symbol})
          </MTypography>
        </Col>
        <Col span={24} className={Spacing.my24}>
          <Row>
            <Col span={24}>
              <MTypography variant='h2' align='center' color={ColorConstant.BRAND6} weight='semibold'>
                <CurrencyField value={position.value} />
              </MTypography>
            </Col>
            <Col span={24}>
              <MTypography variant='h6' align='center' weight='light'>
                Last Price
              </MTypography>
            </Col>
          </Row>
        </Col>
        <Col span={24} className={Spacing.my24}>
          <SecurityDetailsCarousel symbol={position.symbol} />
        </Col>
        <Col span={24}>
          <MFormTextField label='Share Quantity' value={position.quantity} />
        </Col>
        <Col span={24}>
          <MFormTextField label='Share Purchase Price' value={<CurrencyField value={position.purchasePrice} />} />
        </Col>
        <Col span={24}>
          <MFormTextField label='Total Cost' value={<CurrencyField value={position.totalCost} />} />
        </Col>
        <Col span={24}>
          <MFormTextField label='Current Value' value={<CurrencyField value={position.totalValue} />} />
        </Col>
      </MModalBody>
      <MModalFooter>
        <Col span={24} className={cx(Display.flex, AlignItems.center, JustifyContent.spaceBetween)}>
          <MButton type='tertiary' onClick={onClose}>
            Close
          </MButton>
          <Col className={BaseStyle.levelRight}>
            <MButton type='secondary' onClick={onBuy}>
              Buy
            </MButton>
            <MButton onClick={onSell}>Sell</MButton>
          </Col>
        </Col>
      </MModalFooter>
    </>
  );
};
